export const SAVE_TOKEN = "SAVE_TOKEN";
export const SIGN_UP = "SIGN_UP";
export const ERROR_TYPE = "ERROR_TYPE";
export const REMOVE_ERROR = "REMOVE_ERROR";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const REMEMBER_ME = "REMEMBER_ME";
export const AFTER_LOGIN = "AFTER_LOGIN"